import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-social-network-inprocess.component.ajs.html';

const MODULE_NAME = 'agentBookingSocialNetworkInprocess';

class AgentBookingSocialNetworkInprocessCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingSocialNetworkInprocess implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingSocialNetworkInprocessCtrl];
}

export default MODULE_NAME;
